import { useUnit } from 'effector-react';
import $$api from 'models/api';
import navigate from 'models/router-gate';
import { useEffect, useState } from 'react';
import { Button, Col, Form, InputGroup, Modal, Spinner } from 'react-bootstrap';

import CommunityTab from 'components/StyledTemplates/CommunityTab';
import { Frame } from 'components/StyledTemplates/StyledTemplates';

import useModal from 'hooks/useModal';
import useResources from 'hooks/useResources';

import { type QuestionnaireTypeCode } from 'types/zod/questionnaire-type-code';

const NewDocumentModal = () => {
    const [show, setShow] = useState<boolean>(false);
    const [documentTypes, setDocumentTypes] = useState<string[]>([]);
    const [questionnaireTypeCode, setQuestionnaireTypeCode] = useState<QuestionnaireTypeCode>('HIPAA');

    const loading = useUnit($$api.questionnaires.getQTypesFx.pending);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const { close } = useModal('NEW_DOCUMENT', { onOpen: handleShow, onClose: handleClose });

    useEffect(() => {
        $$api.questionnaires.getQTypesFx().then(setDocumentTypes);
    }, []);

    const handleInputChange = (event: any) => {
        setQuestionnaireTypeCode(event.target.value);
    };

    const handleCreate = async () => {
        const result = await $$api.qInstances.createInstanceFx(questionnaireTypeCode);
        setShow(false);
        close();
        navigate(`/document/${questionnaireTypeCode}/${result.state_code}/${result.questionnaire_instance_id}`);
    };

    const { t } = useResources();

    const documentTypeOptions = documentTypes
        .filter((value) => value !== 'EP')
        .map((elem) => {
            return (
                <option key={elem} value={elem}>
                    {t(`documentType.${elem}`)}
                </option>
            );
        });

    const isInputBlocked = documentTypeOptions.length === 0 || loading;

    return (
        <Modal show={show} onHide={handleClose} centered={true} className="new-document-modal modal-temp-class">
            <CommunityTab title={t('newDocument.selectNewDocumentType')}>
                <Form>
                    <Form.Row>
                        <InputGroup>
                            <Form.Group as={Col} controlId="document_type">
                                <Form.Control
                                    as="select"
                                    required
                                    custom
                                    value={questionnaireTypeCode}
                                    onChange={handleInputChange}
                                    disabled={isInputBlocked}
                                >
                                    {documentTypeOptions}
                                </Form.Control>
                            </Form.Group>
                            {loading && (
                                <InputGroup.Append>
                                    <Spinner animation="border" className="ml-2" />
                                </InputGroup.Append>
                            )}
                        </InputGroup>
                    </Form.Row>
                </Form>
                <Frame extra="flex-direction: row;">
                    <Button data-qaid="cancel_button" variant="secondary" onClick={handleClose} className="px-4 mr-1">
                        {t('newDocument.cancel')}
                    </Button>
                    <Button data-qaid="create_button" variant="primary" onClick={handleCreate} className="px-4">
                        {t('newDocument.create')}
                    </Button>
                </Frame>
            </CommunityTab>
        </Modal>
    );
};

export default NewDocumentModal;
